import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import Translator from '../Translator';
import { Modal, Radio } from 'antd';

import { languages } from '../../configs/languages';

import { Wrapper, Flag, RadioGroupContainer, RadioContainer, CustomRadioGroup, ModalTitle, Language } from './style';

import SpainFlag from '../../assets/spain.png';
import BrazilFlag from '../../assets/brazil.png';
import EuaFlag from '../../assets/united-states.png';

import { IoMdClose } from 'react-icons/io';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const theme = useTheme();

  const selectedLanguage = localStorage.getItem('i18nextLng');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
    closeModal();
  };

  const adjustAbbreviation = (abbreviation) => {
    return abbreviation.replace('-', '_');
  };

  return (
    <>
      <Wrapper onClick={openModal}>
        <Flag
          src={selectedLanguage === 'es' ? SpainFlag : selectedLanguage === 'en-US' ? EuaFlag : BrazilFlag}
          alt={t('alt.language')}
        />
        <span>
          <Translator
            path={
              selectedLanguage === 'es'
                ? 'language.spanish'
                : selectedLanguage === 'en-US'
                ? 'language.english'
                : 'language.portuguese'
            }
          />
        </span>
      </Wrapper>
      <Modal
        title={
          <ModalTitle>
            <Translator path={'language.change'} />
          </ModalTitle>
        }
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        styles={{
          body: {
            backgroundColor: theme.background
          },
          content: {
            backgroundColor: theme.background
          },
          header: {
            backgroundColor: theme.background
          }
        }}
        closeIcon={<IoMdClose color={theme.colors.text} size={22} />}
      >
        <CustomRadioGroup onChange={changeLanguage} value={selectedLanguage}>
          <RadioGroupContainer>
            {languages.map((language) => (
              <Radio key={language.abbreviation} value={language.abbreviation}>
                <RadioContainer>
                  <Flag src={language.flag} alt={t(`alt.flags.${adjustAbbreviation(language.abbreviation)}`)} />
                  <Language>{language.name}</Language>
                </RadioContainer>
              </Radio>
            ))}
          </RadioGroupContainer>
        </CustomRadioGroup>
      </Modal>
    </>
  );
}
